import * as React from 'react'

import MutedIcon from '../icons/muted'
import UnmutedIcon from '../icons/unmuted'

import * as styles from './muteSwitcher.module.css'

interface IProps {
  muted: boolean
  onMute: () => any
  onUnmute: () => any
}
const MuteSwitcher = ({
  muted,
  onMute = () => {},
  onUnmute = () => {}
}: IProps) => (
  <div className={styles.root}>
    {muted ? (
      <span className={styles.iconArea} onClick={onUnmute} role="button">
        <MutedIcon width="14" height="14" />
      </span>
    ) : (
      <span className={styles.iconArea} onClick={onMute} role="button">
        <UnmutedIcon width="14" height="14" />
      </span>
    )}
  </div>
)

export default MuteSwitcher
